import PropTypes from 'prop-types'

import NoPermissionsLinkAndButtons from './NoPermissionsLinkAndButtons'

import './noDeputies.scss'

const NoDeputies = props => (
  <div className='no-deputies'>
    <div className='no-deputies__description' >
      This item hasn't been shared yet, and you do not have any Deputies.
    </div>
    <NoPermissionsLinkAndButtons {...props} />
  </div>
)

NoDeputies.propTypes = {
  addNewDeputyLink: PropTypes.func,
  toggleModal: PropTypes.func
}

export default NoDeputies
